// @ts-strict-ignore
import { Grid } from "components/layout/Grid";
import styled from "styled-components";

export const SecurityGrid = styled(Grid)`
  padding-top: 24px;
  padding-bottom: 24px;
  img {
    width: 64px;
    max-height: 130px;
    margin-bottom: 16px;
    height: auto;
  }
  ${(props) => props.theme.media.tablet`
      margin-top: unset;
      img {
        margin-bottom: 0px;
      }
  `}
`;
